import type { GetSimpleFooterResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getSimpleFooter = async (lang?: string) => {
	return await getGenericEndpoint<GetSimpleFooterResponse>('nav/footer', lang);
};
